// extracted by mini-css-extract-plugin
export default {"columns":"Waves_columns__TQH-p","column":"Waves_column__zz99T"};